import React from "react";
import Styles from "./ShowOver.module.css";

const ShowOver = ({ close, uploadProgress }) => {
  return (
    <div className={Styles.overlay}>
      <div className={Styles.overlay_card}>
        {/* Optional close icon */}
        {/* <i className={`bx bx-x ${Styles.icon}`} onClick={close}></i> */}

        {/* Spinner + Upload Percentage */}
        <div className={Styles.loader_container}>
          <div className={Styles.spinner}></div>
          <h2 className={Styles.textcong}>Getting Images: {uploadProgress}%</h2>
          <p className={Styles.notice}>
            Your privacy is important to us.
            <br /> We do not store any facial recognition data.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ShowOver;
